export enum textButton {
    WHITE = "text-white",
    DARK_GREY = "text-dark-grey",
    DARK_GREY_LIGHT = "text-light-grey",
    BLUE = "text-blue-500",
    BLUE_LIGHT = "text-blue-light",
    TRANSPARENT = "text-transparent"
  }